import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';

const FloatingWhatsApp = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
      {/* Menu dépliant */}
      <div 
        className={`mb-4 flex flex-col gap-3 transition-all duration-300 origin-bottom ${
          isOpen ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
        }`}
      >
        <a 
          href="https://wa.me/message/EDWU2IBYEIZQJ1" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3 transition-transform hover:scale-105"
        >
          <FaWhatsapp className="text-2xl" />
          <span className="font-semibold whitespace-nowrap">ITC Santé</span>
        </a>
      </div>

      {/* Bouton principal */}
      <button
        onClick={toggleMenu}
        className="bg-green-600 hover:bg-green-700 text-white p-4 rounded-full shadow-2xl flex items-center justify-center transition-transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-green-300"
        aria-label="Contactez-nous sur WhatsApp"
      >
        {isOpen ? (
          <FaTimes className="text-3xl" />
        ) : (
          <FaWhatsapp className="text-3xl" />
        )}
      </button>
    </div>
  );
};

export default FloatingWhatsApp;
